import VerificationPanel from 'Components/VerificationPanel';
import BlinkItBanner from 'Components/BlinkItBanner';
import 'App.scss'

function App() {
  return (
    <div id="App">
      <VerificationPanel/>
      <BlinkItBanner/>
    </div>
  );
}

export default App;
